module.exports = __webpack_public_path__ + "img/9.6e71e8c4.jpg";